module.exports = __webpack_public_path__ + "img/kucoin.1f3dd98a.svg";